import api from './axios';

export const getOrganizationsApi = (params = {}) => api.get('/admin/organizations', { params }).then((r) => r.data);
export const getOrganizationApi = (id) => api.get(`/admin/organizations/${id}`).then((r) => r.data);
export const getOrganizationRosterApi = (id, params = {}) => api.get(`/admin/organizations/${id}/roster`, { params }).then((r) => r.data);
export const approveOrganizationBillingApi = (id) => api.post(`/admin/organizations/${id}/approve-billing`).then((r) => r.data);
export const recalculateOrganizationPricingApi = (id) => api.post(`/admin/organizations/${id}/recalculate-pricing`).then((r) => r.data);
export const createOrganizationApi = (data) => api.post('/admin/organizations', data).then((r) => r.data);
export const updateOrganizationApi = (id, data) => api.put(`/admin/organizations/${id}`, data).then((r) => r.data);
export const deleteOrganizationApi = (id) => api.delete(`/admin/organizations/${id}`).then((r) => r.data);
export const deleteOrganizationRosterApi = (id) => api.delete(`/admin/organizations/${id}/roster`).then((r) => r.data);
export const createSponsorGroupApi = (formData) =>
  api.post('/admin/organizations/sponsor-group', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
export const createReferralGroupApi = (formData) =>
  api.post('/admin/organizations/referral-group', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);

export const getOrganizationPlanTiersApi = (id) =>
  api.get(`/admin/organizations/${id}/plan-tiers`).then((r) => r.data);

export const updateOrganizationPlanTiersApi = (id, data) =>
  api.put(`/admin/organizations/${id}/plan-tiers`, data).then((r) => r.data);

export const deleteRosterMemberApi = (orgId, rosterId) =>
  api.delete(`/admin/organizations/${orgId}/roster/${rosterId}`).then((r) => r.data);
